import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { PackResponse } from 'app/typings/core/admin/packs/pack';
import type { CreatePackRequest } from 'app/typings/core/admin/packs/packForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCreatePack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreatePackRequest) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createPack },
        payload
      ) as Promise<PackResponse>,
    onSuccess: (response) => {
      message.success(`Package #${response.id} successfully created`);

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.packs],
      });

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.pack, { id: response.id.toString() }],
        response
      );
    },
    onError: () => {
      message.error('Failed to create package.');
    },
  });
}
